<template>
	<v-layout row mt-3>
		<v-flex xs2/>
		<v-flex xs8>
			<v-text-field
				browser-autocomplete="off"
				style="padding-right: 20px"
				aria-label="hint"
				:textarea="true"
				:required="false"
				disabled
				auto-grow
				type="text" v-model="hint"></v-text-field>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: "AgencyFinancialTableHint",

		props: {
			hint: {
				type: String,
				default: ""
			}
		}
	};
</script>

<style scoped>

</style>